/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}.lvisib[_ngcontent-%COMP%]{visibility:hidden}.statdropdown[_ngcontent-%COMP%]   .ui-dropdown[_ngcontent-%COMP%]{min-width:235px!important}"];
export { styles as styles };

